export class BulkUpdateRule {
  selectedIds: Array<number>;
  ownerList: string;

  constructor() {
    this.selectedIds = [];
    this.ownerList = '';
  }
}

export class BulkCheckBoxRule {
  selectedIds: Array<number>;
  isApplicable: boolean;
  isRead: boolean;
  isOperative: boolean;

  constructor(){
    this.selectedIds = [];
    this.isApplicable = false;
    this.isRead = false;
    this.isOperative = false;
  }
}